import { inferAdditionalFields, lastLoginMethodClient, twoFactorClient } from "better-auth/client/plugins";
import { passkeyClient } from "@better-auth/passkey/client";
import { oauthProviderClient } from "@better-auth/oauth-provider/client";
import { createAuthClient } from "better-auth/react"; // make sure to import from better-auth/react
import type { auth } from "./index";
export const authClient = createAuthClient({
	plugins: [
		inferAdditionalFields<typeof auth>(),
		lastLoginMethodClient(),
		twoFactorClient({
			onTwoFactorRedirect() {
				window.location.href = "/auth/2fa";
			},
		}),
		passkeyClient(),
		// Powers the MCP consent page (SAY-31) — approve/deny calls go through this.
		oauthProviderClient(),
	],
});
const setLoginOriginCookie = () => {
	const origin = window.location.origin;
	const hostname = window.location.hostname;
	const domain = hostname === "localhost" ? undefined : hostname.split(".").slice(-2).join(".");
	const cookieParts = [
		"login_origin=" + encodeURIComponent(origin),
		"path=/",
		"max-age=500", // 5 minutes
		"samesite=lax",
	];
	if (domain) {
		cookieParts.push(`domain=.${domain}`);
	}
	document.cookie = cookieParts.join("; ");
};

export const signInEmailTwoFactor = async () => {
	const found = await authClient.getSession();
	if (found.data) {
		window.location.href = "/";
		return;
	}
	setLoginOriginCookie();
	window.location.href = "/auth/2fa";
};

export const signInEmail = async () => {
	const found = await authClient.getSession();
	if (found.data) {
		window.location.href = "/";
		return;
	}
	setLoginOriginCookie();
	window.location.href = "/auth/auth-check";
};

export const signInDoras = async () => {
	const found = await authClient.getSession();
	if (found.data) {
		window.location.href = "/";
		return;
	}
	setLoginOriginCookie();
	await authClient.signIn.social({
		provider: "doras",
		callbackURL: `/auth/auth-check`,
	});
};

export const signInGithub = async () => {
	const found = await authClient.getSession();
	if (found.data) {
		window.location.href = "/";
		return;
	}
	setLoginOriginCookie();
	await authClient.signIn.social({
		provider: "github",
		callbackURL: `/auth/auth-check`,
	});
};

export const signInDiscord = async () => {
	const found = await authClient.getSession();
	if (found.data) {
		window.location.href = "/";
		return;
	}
	setLoginOriginCookie();
	await authClient.signIn.social({
		provider: "discord",
		callbackURL: `/auth/auth-check`,
	});
};

export const signInSlack = async () => {
	const found = await authClient.getSession();
	if (found.data) {
		window.location.href = "/";
		return;
	}
	setLoginOriginCookie();
	await authClient.signIn.social({
		provider: "slack",
		callbackURL: `/auth/auth-check`,
	});
};
